import * as React from 'react'
import { ShopifyNext } from '@dotdev/next-components'
import { GlobalProps } from 'types'
import * as Snippets from 'snippets'
import * as Helpers from 'helpers'
import { trackPromotionClick } from 'helpers'

export class ShopTheLook extends React.PureComponent<ShopTheLook.Props, ShopTheLook.State> {
  public static sectionId = 'shoploo';

  private sliderSettings: any = {
    adaptiveHeight: false,
    autoplay: true,
    autoplaySpeed: 4000,
    dots: true,
    arrows: false,
    infinite: true,
    pauseOnHover: true,
    swipeToSlide: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    centerMode: true,
    vertical: true,
    verticalSwiping: true,
    speed: 500,
    beforeChange: () => {
      const iframes = document.querySelectorAll('iframe')

      Array.prototype.forEach.call(iframes, iframe => {
        var rect = iframe.getBoundingClientRect()
        if ((rect.x + rect.width) < 0 || (rect.y + rect.height) < 0 || (rect.x > window.innerWidth || rect.y > window.innerHeight)) {
          iframe.src = iframe.src + '&enablejsapi=1'
          iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'stopVideo' }), '*')
        }
      })
    },
    appendDots: (dots: any) => {
      return (
        <div className={''}>
          <div className={'slick-dots absolute inset-x-0 lg:pb-12-8'}>
            <ul className={'text-center list-reset'}>{dots}</ul>
          </div>
        </div>
      )
    },
    customPaging: (i: number) => {
      let index = i + 1
      return (
        <button
          key={i}
          className={
            'border inline-block rounded-full border-transparent font-bold opacity-30 text-xs tracking-wide outline-none focus:outline-none p-0-8 mx-0-4 transition'
          }
        >
          {('0' + index).slice(-2)}
        </button>
      )
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          vertical: false,
          verticalSwiping: false,
          centerMode: false
        }
      }
    ]
  }

  private static kewl = new Helpers.ShopifyKewl({
    //@ts-ignore
    store: STOREFRONT_NAME,
    //@ts-ignore
    storeFrontKey: STOREFRONT_PASSWORD
  })
  
  private sliderRef;

  constructor(props: ShopTheLook.Props) {
    super(props)
    this.sliderRef = React.createRef()
    this.next = this.next.bind(this)
    this.previous = this.previous.bind(this)
    this.state = {
      activeProduct: '',
      activeIndex: -1,
      activeSlideIndex: -1,
      activeSlider: null,
      blocks: {},
      wishlist: []
    }
  }
  
  next() {
    this.sliderRef.slickNext()
  }
  previous() {
    this.sliderRef.slickPrev()
  }

  private handleClick = (e, handle, index, slideIndex) => {
    e.preventDefault()
    this.setState({
      activeProduct: handle,
      activeIndex: index,
      activeSlideIndex: slideIndex
    })
  }

  private getSwatchdata = async (products) => {
    const tags = []
    products.forEach(product => {
      if (!product.handle) {
        return
      }
      tags.push(`colours:${[product.handle]}`)
    })
    const siblingsResults = await ShopTheLook.kewl.productsBySwatchTags(tags)
    const newProducts = []
    products.forEach(product => {
      if (!product.id) {
        return
      }
      const underlinedHandle = product?.handle.replace(/\-/g, '_')// eslint-disable-line no-useless-escape
      const siblingsQuantity = siblingsResults[underlinedHandle].length
      const filteredSiblings = siblingsResults[underlinedHandle].filter(sibling => sibling.handle !== product.handle)
      newProducts.push({ ...product, siblingsQuantity: siblingsQuantity, filteredSiblings: filteredSiblings })
    })
    return newProducts
  }

  public componentDidMount = async () => {
    this.props.section.blocks.forEach(async (block, i) => {
      if (Helpers.check(block, 'block.settings.productone.handle') || Helpers.check(block, 'block.settings.producttwo.handle')) {
        const productsQuery = Helpers.check(block, 'block.settings.productone.handle') && Helpers.check(block, 'block.settings.producttwo.handle') ? [block.settings.productone, block.settings.producttwo] : Helpers.check(block, 'block.settings.productone.handle')? [block.settings.productone] :  Helpers.check(block, 'block.settings.producttwo.handle') ? [block.settings.producttwo] : []
        const products = await this.getSwatchdata(productsQuery)
        this.setState(prevState => {
          return {
            blocks: {
              ...prevState.blocks,
              [i]: products
            }
          }
        })
      }
    })
    this.fetchWishlistItems()
  }

  public componentDidUpdate(prevState) {
    this.state.activeSlider && this.state.activeSlideIndex !== prevState.activeSlideIndex
      ? this.state.activeSlider.slickGoTo(this.state.activeSlideIndex)
      : null
  }

  public fetchWishlistItems = () => {
    if (!window._swat || !window._swat.retailerSettings) {
      // console.error("Swat is not initialized");
      setTimeout(() => {
        this.fetchWishlistItems()
      }, 1000)
    } else {
      window._swat?.fetch((res: any) => {
        // console.log("res:", res);
        this.setState({ wishlist: res })
        document.dispatchEvent(new CustomEvent('swym:wishlist-fetched'))
      })
    }
  };
  
  public checkWishlistItem = (product: any) => {
    const { wishlist } = this.state
    if (!product?.handle) {
      return false
    }
    const productId = typeof product.id === 'number' ? product.id : parseInt(product.id?.split('/').pop())
    const productVariantId = typeof product.variants[0]?.id === 'number' ? product.variants[0]?.id : parseInt(product.variants[0]?.id.split('/').pop())
    // console.log('wishlist', wishlist)
    // console.log('product', product)
    if (wishlist.length === 0) {
      console.warn('wishlist is empty')
      return false
    }

    // check if item.id matches any of the res.epi
    const isRes = wishlist.some((r: any) => {
      return r.epi === productId || 
        r.empi === productId || 
        r.epi === productVariantId
    })

    if (isRes) {
      // console.log('wishlist item found')
      return true
    }
    // console.log('wishlist item not found')
    return false
  };
  
  public toggleWishlist = (product: any, isInList: boolean): void => {
    const _this = this
    
    const productId = typeof product.id === 'number' ? product.id : parseInt(product.id?.split('/').pop())
    const productVariantId = typeof product.variants[0]?.id === 'number' ? product.variants[0]?.id : parseInt(product.variants[0]?.id.split('/').pop())
    
    const productData = {
      ...window.SwymPageData,
      et: 4, // et 4 stands for wishlist event type
      epi: productVariantId, // unique variant ID of the product.
      empi: productId, // Product ID or master product ID
      du: `${window.location.origin}/products/${product.handle}`
    }
    
    if (isInList) {
      window._swat.removeFromWishList(
        productData,
        function (e: any) {
          console.log('wishlist item removed', e)
          document.dispatchEvent(new CustomEvent('swym:wishlist-updated'))
          _this.fetchWishlistItems()
        },
        function (e: any) {
          console.log('wishlist item failed', e)
        }
      )
    } else {
      window._swat.addToWishList(
        productData,
        function (e: any) {
          console.log('wishlist item added', e)
          document.dispatchEvent(new CustomEvent('swym:wishlist-updated'))
          _this.fetchWishlistItems()
        },
        function (e: any) {
          console.log('wishlist item failed', e)
        }
      )
    }
  }

  public render(): JSX.Element {
    const { settings, blocks } = this.props.section
    return Object.keys(this.state.blocks).length ? (
      <section className={`dynamic-shop-look overflow-hidden ${settings && settings.color ? `bg-${settings.color}` : ''}
          ${settings && settings.verticalspacing ? 'mb-4' : ''} lg:pt-12-8 pt-5`}>
        <div className={'w-full relative max-w-8xl mx-auto px-0 sm:px-2-4 md:px-6-4'}>
          {settings && settings.addArrows &&
            <button className="button px-1-2" onClick={this.previous}>
              <Snippets.Icon name={'arrow_left'} width={18} label={'previous slide'} />
            </button>}
          <Snippets.Slider settings={{ ...this.sliderSettings }} refs={c => (this.sliderRef = c)}>
            {
              blocks ?
                blocks.map((block: any, i: number) => this.buildItem(block, i, settings.color)) :
                this.placeholder()
            }
          </Snippets.Slider>
          {settings && settings.addArrows &&
            <button className="button px-1-2" onClick={this.next}>
              <Snippets.Icon name={'arrow_right'} width={18} label={'next slide'} />
            </button>}

          <div className={'lg:hidden block absolute inset-x-0 bottom-0'}>
            {
              blocks ?
                blocks.map((block: any, i: number) => this.buildProductItems(block, i, settings.color)) :
                this.placeholder()
            }
          </div>
        </div>
      </section>
    ) : null
  }

  private placeholder = (): JSX.Element[] => {
    const placeholders = Array.from({ length: this.props.section.block_size })
    return placeholders.map((_val: undefined, i: number) => {
      return (
        <div key={i}>
          <div className={'relative'}>
            <div className={'relative'}>
              <Snippets.Image
                alt={'Placeholder loading image'}
                ratio={'2:1'}
                className={'content-placeholder absolute inset-0 hidden lg:block max-h-120'}
                src={null}
              />
              <Snippets.Image
                alt={'Placeholder loading image'}
                ratio={'3:4'}
                className={'content-placeholder absolute inset-0 block lg:hidden max-h-144'}
                src={null}
              />
            </div>
          </div>
        </div>
      )

    })
  }

  private buildItem = (block: any, i: number, backgound: string): JSX.Element => {
    const { settings } = block
    const { image } = settings
    const mobileImage = settings.imagemobile ? settings.imagemobile : settings.image
    const video = settings?.video ? settings?.video : false
    const mobileVideo = settings?.videomobile ? settings?.videomobile : settings?.video ? settings?.video : false
    return (
      <div key={i}>
        <div className={'relative'}>
          <div className={'flex lg:flex-row flex-col-reverse justify-between sm:px-0 px-1-6 h-80 sm:h-auto'}>
            <div className={'w-full lg:w-1/2'}>
              <div className={'relative w-full bg-cover bg-center lg:pr-6-4'}>
                {video ? <>
                  <div className={'w-full sm:block hidden relative'} style={{ height: '794px' }}>
                    <Snippets.Video image={image} video={video} />
                  </div>
                  <div className={'w-full sm:hidden'} style={{ height: '383px' }}>
                    <Snippets.Video image={mobileImage} video={mobileVideo} />
                  </div>
                </> : <>
                  <div className={'bg-cover bg-center w-full sm:block hidden'} style={{ height: '794px', backgroundImage: `url(${Helpers.getSizedImageUrl(image, '1000x')})` }} />
                  <div className={'bg-cover bg-center w-full sm:hidden'} style={{ height: '383px', backgroundImage: `url(${Helpers.getSizedImageUrl(mobileImage, '1000x')})` }} />
                </>}

              </div>
              <div className={'pt-7 lg:hidden flex justify-center pb-3-2'}>
                {settings.linktext ? <Snippets.Button
                  onClick={() => trackPromotionClick(
                    [{
                      id: `${this.props.section.id}-block-${i}`,
                      name: block.settings.title,
                      position: `${i}`,
                      creative: 'Shop the look'
                    }],
                    block.settings.linkurl
                  )}
                  colour={'secondary'}
                  className={'mx-0-3 uppercase tracking-wider bg-transparent'}
                  title={settings.linktext}
                >
                  {settings.linktext}
                </Snippets.Button> : <div className={'h-4'}></div>}
              </div>
            </div>
            <div className={'w-full flex justify-center lg:w-1/2 xl:pr-9 xl:pl-11-6 lg:pl-6 md:pl-0 md:pt-2-4 pt-0 overflow-y-auto hide-scrollbar'}>
              <div className={'w-full content lg:text-left text-center opacity-0'}>
                {settings.title ? (
                  <Snippets.Heading
                    tag={'h2'}
                    size={'h1'}
                    className={'mb-3-6 leading-none'}
                  >
                    {settings.title}
                  </Snippets.Heading>
                ) : null}

                {settings.subtitle ? (
                  <Snippets.Heading
                    tag={'p'}
                    className={'uppercase tracking-wider leading-none font-bold mb-1-4'}
                  >
                    {settings.subtitle}
                  </Snippets.Heading>
                ) : null}

                {settings.content ? (
                  <Snippets.RichText className={'mb-2-4 lg:pr-4-8 leading-base lg:w-3/4 w-full'}>
                    {settings.content}
                  </Snippets.RichText>
                ) : null}

                {settings.linktext ? (
                  <div className={' hidden lg:block'}>
                    <Snippets.Button
                      onClick={() => trackPromotionClick(
                        [{
                          id: this.props.section.id,
                          name: settings.title,
                          creative: 'Shop the look',
                        }],
                        settings.linkurl
                      )}
                      colour={'secondary'}
                      className={'uppercase tracking-wider mb-6-4 bg-transparent'}
                      title={settings.linktext}
                      thin={true}
                    >
                      {settings.linktext}
                    </Snippets.Button>
                  </div>
                ) : null}

                <div className={'hidden lg:flex'}>
                  {settings.productone?.id ?
                    <div className={'w-1/2 bg-white transition-fast opacity-100'}>
                      <Snippets.CollectionProduct
                        collection={Helpers.check(this, 'this.props.data.collection') ? this.props.data.collection : null}
                        product={settings.productone}
                        list="Shop the look"
                        className={'w-full'}
                        noBorder
                        isInWishlist={this.checkWishlistItem(settings.productone)}
                        toggleWishlist={this.toggleWishlist}
                        wishlist={this.state.wishlist}
                        preventLazy={true}
                      />
                    </div>

                    : null}
                  {settings.producttwo?.id ?
                    <div className={'w-1/2 bg-white border-l border-grey transition-fast opacity-100'}>
                      <Snippets.CollectionProduct
                        collection={Helpers.check(this, 'this.props.data.collection') ? this.props.data.collection : null}
                        product={settings.producttwo}
                        list="Shop the look"
                        className={'w-full'}
                        noBorder
                        isInWishlist={this.checkWishlistItem(settings.producttwo)}
                        toggleWishlist={this.toggleWishlist}
                        wishlist={this.state.wishlist}
                        preventLazy={true}
                      />
                    </div>
                    : null}
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    )
  };

  private buildProductItems = (item: any, i: number, backgound: string): JSX.Element => {
    const { settings } = item
    const sliderSettings: any = {
      autoplay: false,
      autoplaySpeed: 4000,
      draggable: false,
      dots: false,
      arrows: true,
      infinite: true,
      pauseOnHover: true,
      swipeToSlide: true,
      slidesToScroll: 1,
      slidesToShow: 2,
      centerMode: false,
      centerPadding: '45px',
      speed: 500,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            centerMode: false,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            centerMode: true,
            swipe: false,
          }
        }
      ]
    }
    return (
      <div key={i} className={`transition absolute z-20 left-0 inset-x-0 sm:pl-6-4 pl-9 bottom-0 sm:px-6-4 ${this.state.activeIndex == i ? 'translate-y:0' : 'translate-y:100'} bg-grey`}>
        <div className={'mobile-slider lg:w-1/2 lg:mx-auto'} >
          <Snippets.Slider
            refs={(slider) => {
              if (this.state.activeIndex === i) {
                this.setState({
                  activeSlider: slider
                })
              }
            }}
            settings={{ ...sliderSettings }}
          >
            {settings.productone?.id ?
              <div className={`w-1/2 bg-white border-r border-grey transition-fast ${this.state.activeProduct == settings.productone.handle ? 'opacity-100' : 'opacity-75'}`}>
                <Snippets.CollectionProduct
                  collection={Helpers.check(this, 'this.props.data.collection') ? this.props.data.collection : null}
                  product={settings.productone}
                  list="Shop the look"
                  className={'w-full'}
                  noBorder
                  isInWishlist={this.checkWishlistItem(settings.productone)}
                  toggleWishlist={this.toggleWishlist}
                  wishlist={this.state.wishlist}
                  preventLazy={true}
                />
              </div>
              : null}
            {settings.producttwo?.id ?
              <div className={`w-1/2 bg-white transition-fast ${this.state.activeProduct == settings.producttwo.handle ? 'opacity-100' : 'opacity-75'}`}>
                <Snippets.CollectionProduct
                  collection={Helpers.check(this, 'this.props.data.collection') ? this.props.data.collection : null}
                  product={settings.producttwo}
                  list="Shop the look"
                  className={'w-full'}
                  noBorder
                  isInWishlist={this.checkWishlistItem(settings.producttwo)}
                  toggleWishlist={this.toggleWishlist}
                  wishlist={this.state.wishlist}
                  preventLazy={true}
                />
              </div>
              : null}
          </Snippets.Slider>
          <div className={'-ml-9 sm:ml-0'}>
            <a className={'w-4 h-4 border border-black bg-white flex justify-center items-center m-auto mt-3-2'}
              onClick={() => this.setState({ activeProduct: '', activeIndex: -1 })}>
              <Snippets.Icon name={'cross'} width={14} label={'close icon'} />
            </a>
          </div>
        </div>
      </div>
    )
  };
}

export namespace ShopTheLook {
  export interface Options extends ShopifyNext.Section<{
    color: string;
    verticalspacing: boolean;
    addArrows: boolean;
  }> {
    block_size: number;
  }
  export interface Props extends GlobalProps {
    section: ShopTheLook.Options;
  }
  export interface State {
    activeProduct: string;
    activeIndex: number;
    activeSlideIndex: number;
    activeSlider: any;
    blocks: any;
    wishlist: any[];
  }
}
